module.exports = __webpack_public_path__ + "img/6852.95bd695a.jpg";